module.exports = __webpack_public_path__ + "img/ekn.b423678.jpg";